<script>
import Swal from "sweetalert2";
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";

export default {
  name: "ProfileExecutives",
  components: {NavbarPage, LoadingPage},
  setup(){
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)

    let profiles = ref([])

    function load_profile() {

      loading.value = true

      FreeWorld.Heisenberg({action: 'excutives',} , 'user_profiles' , true).then((result)=>{

        loading.value = false
        let res  = result.data
        if (res.status !=  'error'){
          profiles.value = res
        }

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_profile()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_profile()
            }
          })
        }
      })

    }
    load_profile()

    function delete_executive(id) {

      Swal.fire({
        text: "آیا میخواهید آگهی را حذف کنید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
        confirmButtonText: "حذف",
        cancelButtonText: "منصرف شدم",
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      }).then((result)=>{

        if (result.isConfirmed){


          loading.value = true
          FreeWorld.Heisenberg({action: 'executives', id: id} , 'delete_items').then((result)=>{

            loading.value = false
            let res = result.data
            if (res.status == 'ok' ){

              Swal.fire({
                position: "center",
                icon: "success",
                title: "پروفایل با موفقیت حذف شد",
                showConfirmButton: false,
                timer: 1500,
              }).then(()=>{
                load_profile()
              })

            }else{

              Swal.fire({
                position: "center",
                icon: "error",
                title: "متاسفانه پروفایل حذف نشد",
                showConfirmButton: false,
                timer: 1500,
              });

            }

          })

        }

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              delete_executive(id)
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              delete_executive(id)
            }
          })
        }
      })

    }


    return{

      loading,
      profiles,
      delete_executive,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" class="bg-main" :class="loading ? 'activeClass' : '' ">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          پروفایل مجری
        </p>

        <div onclick="window.history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>

      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-2">

      <div v-if="profiles.length == 0 " class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/businessman.svg" alt="">
          <br>
          <p class="font-4 ">
            !در حال حاضر شما پروفایلی ندارید
          </p>
        </div>
      </div>



      <div v-else>

        <div v-for="item in profiles" :key="item.id" class="">

          <div class="bg-white mb-2 text-black shadow-costom rounded-4 p-2">

            <router-link :to="{name:'DetailsExecutives' , params:{prof_id: item.id}}" class="d-flex justify-content-between text-decoration-none text-black">
              <div class="">
                <img v-if="item.profile_pic == null " class="img_executives rounded-4" src="../assets/img/img-notavalible.jpg" alt="">

                <img v-else class="img_executives rounded-4" :src="item.profile_pic" alt="">
              </div>

              <div class="w-100 d-flex flex-column justify-content-around px-2 py-2">
                <p class="font-4 font-bold mb-2 text-end">{{ item.name }}</p>
                <p class="text_information mb-2 font-5">{{ item.description }}</p>

                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <p class="m-0 font-5 d-flex">
                      <span>بازدید</span>
                      &nbsp;
                      <span class="font-bold">{{ item.visit }}</span>
                    </p>
                    <img style="width: 1rem" class="mx-1" src="../assets/img/see.svg" alt="">
                  </div>

                  <div class="overflow-hidden d-flex align-items-center">
                    <p class="m-0 font-5 text-end" :class="{'txtoverflow':item.state.length + item.city.length > 15}">
                      <span>{{ item.state }}</span>
                      -
                      <span>{{ item.city }}</span>
                    </p>
                  </div>
                </div>

              </div>
            </router-link>

            <hr>

            <div class="w-100 d-flex justify-content-between">

              <div :to="{name:'ChatsProfile' , params:{'id':item.id , 'type':'executives'}}" class="text-decoration-none w-30 text-black font-bold">
                <v-btn class="rounded-3 w-100 text-black border-costom py-2 px-2 font-5 font-bold bg-main">
                  نمایش چت ها
                  <!--                  <img style="width: 15px" src="../assets/img/increase.svg" alt="">-->
                </v-btn>
              </div>

              <v-btn @click="delete_executive(item.id)" class="rounded-3 w-30 text-black border-costom py-2 px-2 font-5 font-bold bg-red mx-1">
                حذف
                <!--                  <img style="width: 15px" src="../assets/img/trash-bin.svg" alt="">-->
              </v-btn>

              <router-link :to="{name:'NewProfileConsultant' , params:{action:item.id}}" class="text-decoration-none w-30 text-black font-bold">
                <v-btn class="rounded-3 w-100 text-black border-costom py-2 px-2 font-5 font-bold bg-orange">
                  ویرایش
                  <!--                  <img style="width: 15px" src="../assets/img/pencil.svg" alt="">-->
                </v-btn>
              </router-link>


            </div>

          </div>

        </div>

      </div>

    </div>

    <br>
    <br>
    <br>
    <div class="new_profile w-100 max_width">
      <router-link :to="{name:'NewProfileConsultant' , params:{action: 'new'}}" class="text-decoration-none" >
        <v-btn class="p-3 h-100 border-costom rounded-4 bg-color font-4 text-white mx-4">
          ساخت پروفایل جدید
        </v-btn>
      </router-link>
    </div>
  </div>

  <div id="web" class="bg-main" :class="loading ? 'activeClass' : '' ">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold text-end font-color p-3 mb-3 w-75 ma-auto">پروفایل مجری</div>

    <div class="p-4 bg-white rounded-4 w-75 m-auto">

      <div v-if="profiles.length == 0 " class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/businessman.svg" alt="">
          <br>
          <p class="font-4 ">
            در حال حاضر شما پروفایلی ندارید!
          </p>
        </div>
      </div>



      <div v-else>

        <div v-for="item in profiles" :key="item.id" class="">

          <div class="bg-white mb-2 text-black shadow-costom rounded-4 p-2">

            <router-link :to="{name:'DetailsExecutives' , params:{prof_id: item.id}}" class="d-flex justify-content-between text-decoration-none text-black">

              <div class="">
                <img v-if="item.profile_pic == null " class="img_executives rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
                <img v-else class="img_executives rounded-4" :src="item.profile_pic" alt="">
              </div>

              <div class="w-100 px-2 py-2 d-flex flex-column justify-content-around">
                <p class="font-4 font-bold mb-2 text-end">{{ item.name }}</p>
                <p class="text_information mb-2 font-5">{{ item.description }}</p>
                <div class="d-flex justify-content-between">
                  <div>
                    <p class="m-0 font-5 text-end">
                      <span>{{ item.state }}</span>
                      -
                      <span>{{ item.city }}</span>
                    </p>
                  </div>

                  <div class="d-flex">
                    <img style="width: 18px" class="mx-1" src="../assets/img/see.svg" alt="">
                    <p class="m-0 font-5 d-flex">
                      <span class="font-bold">{{ item.visit }}</span>
                      &nbsp;
                      <span>بازدید</span>
                    </p>
                  </div>
                </div>
              </div>
            </router-link>

            <hr>

            <div class="w-100 d-flex justify-content-between">

              <router-link :to="{name:'ChatsProfile' , params:{'id':item.id , 'type':'executives'}}" class="text-decoration-none w-30 text-black font-bold">
                <v-btn style="height: 3rem" class="rounded-3 w-100 text-black border-costom px-2 font-5 font-bold bg-main">
                  نمایش چت ها
                  <!--                  <img style="width: 15px" src="../assets/img/increase.svg" alt="">-->
                </v-btn>
              </router-link>

              <v-btn style="height: 3rem" @click="delete_executive(item.id)" class="rounded-3 w-30 text-black border-costom px-2 font-5 font-bold bg-red mx-1">
                حذف
                <!--                  <img style="width: 15px" src="../assets/img/trash-bin.svg" alt="">-->
              </v-btn>

              <router-link :to="{name:'NewProfileConsultant' , params:{action:item.id}}" class="text-decoration-none w-30 text-black font-bold">
                <v-btn style="height: 3rem" class="rounded-3 w-100 text-black border-costom px-2 font-5 font-bold bg-orange">
                  ویرایش
                  <!--                  <img style="width: 15px" src="../assets/img/pencil.svg" alt="">-->
                </v-btn>
              </router-link>


            </div>

          </div>

        </div>

      </div>

    </div>


    <div class="new_profile w-100 max_width">
      <router-link :to="{name:'NewProfileConsultant' , params:{action: 'new'}}" class="text-decoration-none" >
        <v-btn class="p-3 h-100 border-costom rounded-4 bg-color font-4 text-white mx-4">
          ساخت پروفایل جدید
        </v-btn>
      </router-link>
    </div>
  </div>

</template>

<style scoped>

.new_profile {
  position: fixed;
  bottom: 20px;
}
.img_executives{
  width: 9rem;
  height: 9rem;
}
.text_information{
  height: 3rem;
  width: 100%;
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
  display: flex;
  align-items: center;
}

</style>